<script>
  import isMobile from 'stores/isMobile'
</script>

<button class='btn btn-sm btn-outline-secondary mr-1' type='button'
    class:active={$isMobile} on:click={() => { $isMobile = !$isMobile }}>
  手機模式
</button>
